export default __webpack_public_path__ + "static/media/jpg.0da7f691.svg";